import script from "./PartenairesView.vue?vue&type=script&setup=true&lang=js"
export * from "./PartenairesView.vue?vue&type=script&setup=true&lang=js"

import "./PartenairesView.vue?vue&type=style&index=0&id=27ef99e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27ef99e5"]])

export default __exports__